export default {
    topics: [
        {
            title: ' generateRegisterHookScript ',
            href: 'sm-mobileApp-generateRegisterHookScript.html',
            attributes: { 'data-id': 'sm-mobileApp-generateRegisterHookScript' },
            menu: { hasChildren: false },
            tocID: 'sm-mobileApp-generateRegisterHookScript-d66e3165',
            topics: [],
        },
        {
            title: ' iOSCreateProductionApp ',
            href: 'sm-mobileApp-iOSCreateProductionApp.html',
            attributes: { 'data-id': 'sm-mobileApp-iOSCreateProductionApp' },
            menu: { hasChildren: false },
            tocID: 'sm-mobileApp-iOSCreateProductionApp-d66e3173',
            topics: [],
        },
        {
            title: ' iOSGenerateCertificate ',
            href: 'sm-mobileApp-iOSGenerateCertificate.html',
            attributes: { 'data-id': 'sm-mobileApp-iOSGenerateCertificate' },
            menu: { hasChildren: false },
            tocID: 'sm-mobileApp-iOSGenerateCertificate-d66e3181',
            topics: [],
        },
        {
            title: ' iOSResetConnectionCache ',
            href: 'sm-mobileApp-iOSResetConnectionCache.html',
            attributes: { 'data-id': 'sm-mobileApp-iOSResetConnectionCache' },
            menu: { hasChildren: false },
            tocID: 'sm-mobileApp-iOSResetConnectionCache-d66e3189',
            topics: [],
        },
        {
            title: ' iOSTestConnection ',
            href: 'sm-mobileApp-iOSTestConnection.html',
            attributes: { 'data-id': 'sm-mobileApp-iOSTestConnection' },
            menu: { hasChildren: false },
            tocID: 'sm-mobileApp-iOSTestConnection-d66e3197',
            topics: [],
        },
        {
            title: ' resetServiceMobileAppsCustomHook ',
            href: 'sm-mobileApp-resetServiceMobileAppsCustomHook.html',
            attributes: { 'data-id': 'sm-mobileApp-resetServiceMobileAppsCustomHook' },
            menu: { hasChildren: false },
            tocID: 'sm-mobileApp-resetServiceMobileAppsCustomHook-d66e3205',
            topics: [],
        },
    ],
};

